<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      坪环站<br>
站点介绍<br>
坪环站位于坪山区东纵路与中兴路交叉口处，车站主体沿东纵路呈东西走向布置。东接东纵纪念馆站，西接坪山围站。车站色彩基调以白色调为主，以“新居”为主题，运用清新淡雅的科技蓝色营造时尚现代的空间。车站为地下二层结构，地下一层为站厅层，地下二层为站台层，站台形式为岛式站台。车站设置有3个出入口，临近深圳市坪山区人民医院、坪山中学、大万世居、中兴西小区，周边为成熟配套生活区。<br><br>
运营时刻表(工作日)<br><br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:26	23:35	16号线	5分32秒	6分49秒<br>
田心	06:03	23:12	16号线	5分32秒	6分49秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:36	23:35	16号线	5分50秒	6分钟-9分钟<br>
田心	06:03	23:12	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:36	00:35	16号线	5分50秒	6分钟-9分钟<br>
田心	06:03	00:12	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A1出入口:<br>
东纵路南侧（西）、均田二路、坪山汽车总站、万顺苑、大万世居<br><br>
A2出入口:<br>
东纵路北侧（西）、中兴东小区、中兴西小区、中兴路、坪山中心小学<br><br>
D出入口:<br>
东纵路北侧（东）、中兴东小区，坪山中学、坪环社区居委会、坪山区东门小学<br>
公交换乘信息<br><br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>